"use client";

import { Target, Network, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const features = [{
  title: "Lighting Scenes",
  description: "Discover how to create the perfect ambiance for every moment using Apple Homekit's adaptive lighting and automated scenes.",
  icon: Target
}, {
  title: "Climate Control",
  description: "Master the art of simple living with smart thermostats that learn your routine and keep your home comfortable effortlessly.",
  icon: Network
}, {
  title: "Secure Entry",
  description: "Explore the peace of mind that comes with HomeKit Secure Video and smart locks, keeping your sanctuary safe and private.",
  icon: ShieldCheck
}];
export default function Features() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}